function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.75 3C7.75 4.10457 6.85457 5 5.75 5C4.64543 5 3.75 4.10457 3.75 3C3.75 1.89543 4.64543 1 5.75 1C6.85457 1 7.75 1.89543 7.75 3Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.75 5C4.09315 5 2.75 5.89543 2.75 7C2.75 8.10457 4.09315 9 5.75 9C7.40685 9 8.75 8.10457 8.75 7C8.75 5.89543 7.40685 5 5.75 5Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.75 17C17.8546 17 18.75 16.1046 18.75 15C18.75 13.8954 17.8546 13 16.75 13C15.6454 13 14.75 13.8954 14.75 15C14.75 16.1046 15.6454 17 16.75 17Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.75 17C18.4069 17 19.75 17.8954 19.75 19C19.75 20.1046 18.4069 21 16.75 21C15.0931 21 13.75 20.1046 13.75 19C13.75 17.8954 15.0931 17 16.75 17Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 2C10 1.58579 10.3358 1.25 10.75 1.25C16.1348 1.25 20.5 5.61522 20.5 11C20.5 11.4142 20.1642 11.75 19.75 11.75C19.3358 11.75 19 11.4142 19 11C19 6.44365 15.3063 2.75 10.75 2.75C10.3358 2.75 10 2.41421 10 2Z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.75 10.25C2.16421 10.25 2.5 10.5858 2.5 11C2.5 15.5563 6.19365 19.25 10.75 19.25C11.1642 19.25 11.5 19.5858 11.5 20C11.5 20.4142 11.1642 20.75 10.75 20.75C5.36522 20.75 1 16.3848 1 11C1 10.5858 1.33579 10.25 1.75 10.25Z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.75 5C6.85457 5 7.75 4.10457 7.75 3C7.75 1.89543 6.85457 1 5.75 1C4.64543 1 3.75 1.89543 3.75 3C3.75 4.10457 4.64543 5 5.75 5ZM5.75 5C4.09315 5 2.75 5.89543 2.75 7C2.75 8.10457 4.09315 9 5.75 9C7.40685 9 8.75 8.10457 8.75 7C8.75 5.89543 7.40685 5 5.75 5ZM16.75 17C17.8546 17 18.75 16.1046 18.75 15C18.75 13.8954 17.8546 13 16.75 13C15.6454 13 14.75 13.8954 14.75 15C14.75 16.1046 15.6454 17 16.75 17ZM16.75 17C18.4069 17 19.75 17.8954 19.75 19C19.75 20.1046 18.4069 21 16.75 21C15.0931 21 13.75 20.1046 13.75 19C13.75 17.8954 15.0931 17 16.75 17ZM10.75 1.25C10.3358 1.25 10 1.58579 10 2C10 2.41421 10.3358 2.75 10.75 2.75C15.3063 2.75 19 6.44365 19 11C19 11.4142 19.3358 11.75 19.75 11.75C20.1642 11.75 20.5 11.4142 20.5 11C20.5 5.61522 16.1348 1.25 10.75 1.25ZM2.5 11C2.5 10.5858 2.16421 10.25 1.75 10.25C1.33579 10.25 1 10.5858 1 11C1 16.3848 5.36522 20.75 10.75 20.75C11.1642 20.75 11.5 20.4142 11.5 20C11.5 19.5858 11.1642 19.25 10.75 19.25C6.19365 19.25 2.5 15.5563 2.5 11Z",
  strokeWidth: 1.2
});

var SvgNutritionistFill = function SvgNutritionistFill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    stroke: "none",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNutritionistFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nutritionist-fill.2f746c86.svg";
export { ForwardRef as ReactComponent };